
import {
    message,
} from 'antd'

import _ from 'lodash'

class SettingsHandler {

    constructor(comp, service){
        this.comp = comp;
        this.service = service;
    }

    get folder() { return this.comp.state.selectedFolder };

    get file() { return this.comp.getFirstSelectedFile()};

    get folderPath() { return this.comp.state.folderPath; }

    get users() { return this.comp.state.settings.users; }

    get selectedOwner() { return this.comp.state.settings.selectedOwner; }

    get selectedGuests() { return this.comp.state.settings.selectedGuests; }

    get iconColor() { return this.comp.state.settings.iconColor; }

    get textSize() { return this.comp.state.settings.textSize; }

    get textStyle() { return this.comp.state.settings.textStyle; }

    get folderComments() { return this.comp.state.settings.folderComments; }

    get fileComments() { return this.comp.state.settings.fileComments; }

    updateState = (newState) => {
        this.comp.setState({
            settings: {
                ...this.comp.state.settings, ...newState
            }
        });
    }

    onChangeOwner = value => {
        this.updateState( { selectedOwner: value });
    }

    onChangeGuests = values => {
        this.updateState( { selectedGuests: values });
    }

    onChangeIconColor = e => {
        this.updateState( { iconColor: e.target.value });
    }

    onChangeTextSize = e => {
        this.updateState( { textSize: e.target.value });
    }

    onChangeTextStyle = values => {
        this.updateState( { textStyle: values });
    }

    onChangeFolderComments = e => {
        this.updateState( { folderComments: e.currentTarget.value });
    }

    onChangeFileComments = e => {
        this.updateState( { fileComments: e.currentTarget.value });
    }

    handleFolderGenerateLink = async () => {
        console.log('handleGenerateLink:', this.folder)
        const folderId = this.folder._id
        const rsp = await this.service.generateFolderSharedLink(folderId)
        if (rsp.rspCode === 'ok') {
            console.log('rsp:', rsp);
            this.folder.publicLink = rsp.publicLink;
            this.updateState({folderLink: rsp.publicLink});
            message.success('shared link generated successfully')
        } else {
            console.error(rsp)
        }
    }

    handleFileGenerateLink = async () => {
        console.log('handleGenerateLink:', this.file)
        const fileId = this.file._id
        const rsp = await this.service.generateFileSharedLink(fileId)
        if (rsp.rspCode === 'ok') {
            console.log('rsp:', rsp)
            this.file.publicLink = rsp.publicLink
            this.updateState({fileLink: rsp.publicLink});
        } else {
            console.error(rsp)
        }
    }

    saveFolderSecurity = async () => {
        const folderId = this.folder._id
        const folderPath = this.folderPath
        const secDetail = {
            owner: this.selectedOwner,
            guests: _.map(this.selectedGuests, g => {
                return { username: g }
            }),
        }

        const rsp = await this.service.saveFolderSecurity(
            folderId,
            folderPath,
            secDetail
        )
        if (rsp.rspCode === 'ok') {
            message.success('Security properties were saved successfully')
            this.folder.securityDetail = secDetail;
        } else {
            message.error('Something went wrong while saving...')
        }
    }

    saveStyles = async () => {
        const folderId = this.folder._id
        const folderPath = this.folderPath
        const rsp = await this.service.saveStyles(
            folderId,
            folderPath,
            this.iconColor,
            this.textStyle,
            this.textSize
        )
        if (rsp.rspCode === 'ok') {
            console.log('saveStyles: rsp=', rsp)
            delete rsp['rspCode']
            this.folder.stateColor = rsp.stateColor
            this.folder.textBoldStyle = rsp.textBoldStyle
            this.folder.textItalicStyle = rsp.textItalicStyle
            this.folder.textSize = rsp.textSize

            this.comp.setState({
                selectedFolder: this.folder
            })
            message.success('Style properties were saved successfully')

        } else {
            message.error('Something went wrong while saving...')
        }
    }

    saveFolderComments = async () => {
        const folderId = this.folder._id
        const rsp = await this.service.saveFolderComments(
            folderId,
            this.folderComments
        )
        if (rsp.rspCode === 'ok') {
            console.log('saveStyles: rsp=', rsp)
            this.folder.comments = this.folderComments
            message.success('Comments were saved successfully')
        } else {
            message.error('Something went wrong while saving...')
        }
    }

    saveFileComments = async () => {
        const fileId = this.file._id
        const rsp = await this.service.saveFileComments(
            fileId,
            this.fileComments
        )
        if (rsp.rspCode === 'ok') {
            console.log('saveStyles: rsp=', rsp)
            this.file.comments = this.fileComments
            message.success('Comments were saved successfully')
        } else {
            message.error('Something went wrong while saving...')
        }
    }


}

export default SettingsHandler